export default __webpack_public_path__ + "static/media/keplr-big.f04ca33e.svg";